import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center mb-12">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            准备好开始你的<br />韩漫之旅了吗？
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-4 leading-relaxed">
            海量高清韩漫等你来发现，现在就加入尾巴漫画网，开启属于你的漫画世界
          </p>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer mt-8"
          >
            立即开始阅读
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="flex items-center justify-center gap-4 md:gap-8 flex-wrap">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20character%20standing%20pose%2C%20handsome%20male%20lead%20with%20dark%20hair%2C%20modern%20fashion%20style%2C%20clean%20white%20background%2C%20isolated%20character%20design%2C%20professional%20webtoon%20art%2C%20full%20body%20illustration&width=600&height=800&seq=cta-character-01&orientation=portrait"
            alt="韩漫角色"
            className="h-32 md:h-44 w-auto object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20female%20character%2C%20elegant%20woman%20with%20long%20hair%2C%20beautiful%20dress%2C%20clean%20white%20background%2C%20isolated%20character%20design%2C%20professional%20webtoon%20illustration%2C%20full%20body&width=600&height=800&seq=cta-character-02&orientation=portrait"
            alt="韩漫角色"
            className="h-32 md:h-44 w-auto object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20character%2C%20young%20warrior%20with%20sword%2C%20dynamic%20pose%2C%20clean%20white%20background%2C%20isolated%20character%20design%2C%20professional%20webtoon%20illustration%2C%20full%20body&width=600&height=800&seq=cta-character-03&orientation=portrait"
            alt="韩漫角色"
            className="h-32 md:h-44 w-auto object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20girl%20character%2C%20cute%20style%2C%20school%20uniform%2C%20clean%20white%20background%2C%20isolated%20character%20design%2C%20professional%20webtoon%20illustration%2C%20full%20body&width=600&height=800&seq=cta-character-04&orientation=portrait"
            alt="韩漫角色"
            className="h-32 md:h-44 w-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}